// NPM Imports
import React from "react";

const EmptyScreen = props => {
  const { imageSrc, message } = props;
  return (
    <div className="emptyscreen-wrapper">
      <div className="emptyscreen-img-wrapper">
        <img src={imageSrc} className="emptyscreen-img" alt="Empty Screen" />
      </div>
      <div className="emptyscreen-message" data-test="emptyscreen-message">
        {message}
      </div>
    </div>
  );
};

export default EmptyScreen;



// WEBPACK FOOTER //
// ./src/commonComponents/EmptyScreen/index.js